/* Pattern styles */
import "./pattern.scss";

wp.domReady(() => {
    // Start Front-End Javascript
    const contactModals = document.querySelectorAll(
        ".bod-block-popup.modal-block"
    );

    // Append Position/Title to Contact Modal Title
    contactModals.forEach((contactModal) => {
        // Get all necessary elements
        const title = contactModal.querySelector(".type_text");
        const position = contactModal.querySelector(".modal-block__subtext");
        const positionClone = position.cloneNode(true);

        // If it position already exists, skip
        if (!title.querySelector(".modal-block__subtext")) {
            const modalTitle = contactModal.querySelector(".bod-modal-title");
            modalTitle.appendChild(position);
            title.appendChild(positionClone);
        }
    });
});
